module.exports = __webpack_public_path__ + "static/media/livraria.de89bcab.jpg";